import Vue from "vue";
import Vuex from "vuex";
import storage from "store";

Vue.use(Vuex);

let state = {
  token: storage.get("token"),
  user: storage.get("user") || {},
};

export default new Vuex.Store({
  state,
  mutations: {
    update(state, [key, value]) {
      state[key] = value;
    },
    save(state, [key, value]) {
      state[key] = value;
      storage.set(key, value);
    },
  },
  actions: {
    logout({ commit }) {
      commit("save", ["user", {}]);
      commit("save", ["token", null]);
    },
  },
});
